export default {
    LIST: 'location.list',
    API: {
        LIST: 'location',
        STORE: 'location',
        SHOW: 'location/{locationId}',
        UPDATE: 'location/{locationId}',
        DELETE: 'location/{locationId}'
    }
};
